import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "bodyStyle", "className", "popoverProps", "datePickerProps", "allowClear", "format", "onChange", "value"];
import React, { useEffect, useState } from 'react';
import Input from '@uiw/react-input';
import Popover from '@uiw/react-popover';
import DatePicker from '@uiw/react-date-picker';
import Icon from '@uiw/react-icon';
import formatter from '@uiw/formatter';
import "./style/date-input-range.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function DateInputRange(props) {
  var {
      prefixCls = 'w-dateinputrange',
      bodyStyle = undefined,
      className,
      popoverProps,
      datePickerProps,
      allowClear = true,
      format = 'YYYY/MM/DD',
      onChange,
      value
    } = props,
    inputProps = _objectWithoutPropertiesLoose(props, _excluded);
  var [dateRange, setDateRange] = useState([]);
  useEffect(() => {
    var valueTemp = [];
    var propsValue = value;
    if (Array.isArray(propsValue) && !!(propsValue != null && propsValue.length)) {
      propsValue.forEach((date, index) => {
        valueTemp[index] = typeof propsValue[index] === 'string' ? new Date(date) : date;
      });
    }
    setDateRange(valueTemp);
  }, [JSON.stringify(value)]);
  function handleChange(cdate, idx) {
    var changeValue = [...dateRange];
    changeValue[idx] = cdate;
    setDateRange(changeValue);
    onChange && onChange(cdate, changeValue);
  }
  function clearDateRange() {
    setDateRange([]);
    onChange && onChange(undefined, []);
  }
  return /*#__PURE__*/_jsxs("div", {
    className: [prefixCls + "-contents", prefixCls + "-inner"].filter(Boolean).join(' ').trim(),
    style: _extends({
      width: 300
    }, bodyStyle),
    children: [/*#__PURE__*/_jsx(Popover, _extends({
      trigger: "focus",
      placement: "bottomLeft",
      autoAdjustOverflow: true
    }, popoverProps, {
      content: /*#__PURE__*/_jsx(DatePicker, _extends({
        date: dateRange[0],
        className: prefixCls + "-popover"
      }, datePickerProps, {
        onChange: selectedDate => handleChange(selectedDate, 0)
      })),
      children: /*#__PURE__*/_jsx(Input, _extends({
        placeholder: "\u8BF7\u9009\u62E9\u65E5\u671F",
        readOnly: true
      }, inputProps, {
        // onChange={(v) => console.log('v', v)}
        value: dateRange[0] ? formatter(format, dateRange[0]) : '',
        className: [prefixCls, className].filter(Boolean).join(' ').trim()
      }))
    })), /*#__PURE__*/_jsx(Icon, {
      type: "swap-right",
      verticalAlign: "baseline",
      style: {
        fontSize: 21,
        top: -1,
        margin: '0px 8px 0px 5px'
      }
    }), /*#__PURE__*/_jsx(Popover, _extends({
      trigger: "focus",
      placement: "bottomLeft",
      autoAdjustOverflow: true
    }, popoverProps, {
      content: /*#__PURE__*/_jsx(DatePicker, _extends({
        date: dateRange[1],
        className: prefixCls + "-popover"
      }, datePickerProps, {
        onChange: selectedDate => handleChange(selectedDate, 1)
      })),
      children: /*#__PURE__*/_jsx(Input, _extends({
        placeholder: "\u8BF7\u9009\u62E9\u65E5\u671F",
        readOnly: true
      }, inputProps, {
        value: dateRange[1] ? formatter(format, dateRange[1]) : ''
        // onChange={(v) => console.log('v2', v)}
        ,
        className: [prefixCls, className].filter(Boolean).join(' ').trim()
      }))
    })), allowClear && dateRange.length > 0 && /*#__PURE__*/_jsx(Icon, {
      className: prefixCls + "-close-btn",
      color: "#a5a5a5",
      onClick: () => clearDateRange(),
      type: "close"
    })]
  });
}